import React from "react";
import LegalPage from "Pages/Legal";
import termsData from "data/terms-of-service.json";

const TermsOfService: React.FC = () => <LegalPage legalDoc={termsData} />;

export default TermsOfService;